import { clusterIdSchema, dateStringSchema, endpointIdSchema, hasExactKeys, ieeeSchema } from '../../util/valibot';
import { addressSchema } from './Address';
import * as v from 'valibot';
const bindingTableSourceSchema = v.object({
    cluster: clusterIdSchema,
    endpoint: endpointIdSchema,
    ieee: ieeeSchema,
});
export const bindingTableItemSchema = v.object({
    destination: addressSchema,
    source: bindingTableSourceSchema,
});
export const bindingTableSchemaNew = v.object({
    fetched_ts: dateStringSchema,
    items: v.array(bindingTableItemSchema),
});
export const bindingTableItemWithoutDestinationWithDestGroupSchema = v.pipe(v.object({
    src_cluster: clusterIdSchema,
    src_ep: endpointIdSchema,
    src_ieee: ieeeSchema,
    dest_group: v.number(),
}), v.transform((s) => ({
    destination: { group: s.dest_group },
    source: {
        cluster: s.src_cluster,
        endpoint: s.src_ep,
        ieee: s.src_ieee,
    }
})));
export const bindingTableItemWithoutDestinationWithDestEp = v.pipe(v.object({
    src_cluster: clusterIdSchema,
    src_ep: endpointIdSchema,
    src_ieee: ieeeSchema,
    dest_ep: endpointIdSchema,
    dest_ieee: ieeeSchema,
}), v.transform((s) => ({
    destination: {
        endpoint: s.dest_ep,
        ieee: s.dest_ieee,
    },
    source: {
        cluster: s.src_cluster,
        endpoint: s.src_ep,
        ieee: s.src_ieee,
    }
})));
// Check only the keys to identify which kind of object it is
// and then parse exactly that. This give better error messages.
export const bindingTableSchemaItemOld = v.lazy((s) => {
    if (hasExactKeys(bindingTableItemSchema, s)) {
        return bindingTableItemSchema;
    }
    else if (hasExactKeys(bindingTableItemWithoutDestinationWithDestGroupSchema, s)) {
        return bindingTableItemWithoutDestinationWithDestGroupSchema;
    }
    else if (hasExactKeys(bindingTableItemWithoutDestinationWithDestEp, s)) {
        return bindingTableItemWithoutDestinationWithDestEp;
    }
    else {
        return v.never('Expected a BindingTableItem');
    }
});
export const bindingTableSchemaOld = v.pipe(v.array(bindingTableSchemaItemOld), v.transform((s) => ({
    fetched_ts: (new Date(0).toISOString()),
    items: s,
})));
export const bindingTableSchema = v.lazy((s) => Array.isArray(s) ? bindingTableSchemaOld : bindingTableSchemaNew);
